import { Card } from '@change-corgi/design-system-legacy/components/content';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { ImageUploadProvider } from 'src/app/shared/hooks/imageUpload';

import { CreatePetitionUpdateForm } from './components/CreatePetitionUpdateForm';
import { CreatePetitionUpdateContext } from './components/CreatePetitionUpdateForm/context';
import { FilledTemplateNotice } from './components/FilledTemplateNotice';
import { Header } from './components/Header';
import { SuggestedTemplateNotice } from './components/SuggestedTemplateNotice';
import { useUpdateSupporters } from './hooks/useUpdateSupporters';

export function UpdateSupporters() {
	const {
		data: { shouldShowSuggestedTemplateNotice, isTemplateFilled },
		actions: { handleUserClickSuggestionAi },
	} = useUpdateSupporters();

	return (
		<Box as="section" aria-labelledby="update-your-supporters-module" data-qa="update-your-supporters-module">
			<Card
				p={24}
				backgroundColor="white"
				sx={{
					border: 'unset',
					width: '100%',
					borderRadius: 'big',
				}}
			>
				<Header />
				{shouldShowSuggestedTemplateNotice && <SuggestedTemplateNotice onClick={handleUserClickSuggestionAi} />}
				{isTemplateFilled && <FilledTemplateNotice />}
				<CreatePetitionUpdateContext.Provider value={isTemplateFilled}>
					<ImageUploadProvider>
						<CreatePetitionUpdateForm />
					</ImageUploadProvider>
				</CreatePetitionUpdateContext.Provider>
			</Card>
		</Box>
	);
}
